import { Controller } from "@hotwired/stimulus";

// Plain Stimulus controller on the Hotwire Native OAuth-return page (see
// app/views/hotwire_native/oauth_returns/show.html.haml) — NOT a bridge
// component, because the one place this needs to act is a context where no
// bridge exists.
//
// That page loads in two different browsers:
//
//   - The external auth browser (ASWebAuthenticationSession on iOS, a Chrome
//     Custom Tab on Android), once the social-account OAuth flow finishes
//     there. Its User-Agent is plain Safari/Chrome — it does NOT match
//     /Hotwire Native/ — so there's no bridge to send a message over. The only
//     way to tell the shell "the auth session is done" is to navigate to our
//     custom URL scheme: iOS detects it via ASWebAuthenticationSession's
//     callbackURLScheme, Android via an intent-filter (see native/ios and
//     native/android), and both close the auth browser and refresh the tab
//     that started the connect.
//   - The app's own webview, whose User-Agent does match /Hotwire Native/.
//     This controller is a no-op there — the existing bridge--connect
//     component (bridge/connect_controller.js) owns that path.
export default class extends Controller {
  static values = { status: String, message: String };

  connect() {
    if (/Hotwire Native/.test(navigator.userAgent)) return;

    const status = this.statusValue || "error";
    const msg = this.hasMessageValue ? this.messageValue : "";
    window.location.replace(
      "influencekit://oauth_complete?status=" +
        status +
        "&msg=" +
        encodeURIComponent(msg)
    );
  }
}
